/**
 * Icon Constants
 */

const windowPathname = window.location.pathname;
const BASE_ICON_SPRITE_PREFIX_FOR_V1 = windowPathname.includes('/v1/') && '/v1';
const BASE_ICON_SPRITE_PRIFEX: string =
  BASE_ICON_SPRITE_PREFIX_FOR_V1 || (windowPathname.includes('/v2/') ? '/v2' : '');
export const BASE_ICON_SPRITE_PATH = '/img/rd-icons/rd-icons-sprite/rd-icons.svg';
export const BASE_RD_ICON_PREFIX = '#rd-icon-';

/**
 * Icon Sizes
 */
export enum IconSize {
  XXXSMALL = 'xxxs',
  XXSMALL = 'xxs',
  XSMALL = 'xs',
  SMALL = 's',
  MEDIUM = 'm',
  LARGE = 'l',
  XLARGE = 'xl',
  XXLARGE = 'xxl',
  XXXLARGE = 'xxxl',
}

/**
 * Icon Colors
 *
 * Note: Text Color listens to the color of the text (CSS Property 'color') of the nearest element or ancestor element
 */
export enum IconColor {
  BLACK = 'black',
  BLUE = 'blue',
  TEXT_COLOR = 'text-color',
  WHITE = 'white',
  GRAY = 'gray',
  GREEN = 'green',
  RED = 'red',
  YELLOW = 'yellow',
  LIGHTGRAY = 'lightgray',
  DARKGRAY = 'darkgray',
  MEDIUMGRAY = 'mediumgray',
}

/**
 * Icon IDs library
 * For new icons, add SVGs to `radiant-styles` at
 *   `js/ts-packages/radiant-styles/resources/img/rd-icons/`.
 */
export enum IconID {
  ABOUT = 'about',
  ADD = 'add',
  ADD_SELECTED = 'add-selected',
  ADD_USER = 'add-user',
  AGENDA = 'agenda',
  AI = 'ai',
  AI_SPARKLE = 'ai-sparkle',
  AI_SPARKLE_SELECTED = 'ai-sparkle-selected',
  ANNOTATE_ACTIVE = 'annotate-active',
  ANNOTATE_UNREAD = 'annotate-unread',
  ANNOTATE_RESTING = 'annotate-resting',
  ANSWER = 'answer',
  ANSWER_HOME = 'answer-home',
  ANSWER_OUTLINE = 'answer-outline',
  ARROW_DOWN = 'arrow-down',
  ARROW_DOWN_CIRCLE = 'arrow-down-circle',
  ARROW_LEFT = 'arrow-left',
  ARROW_LEFT_CIRCLE = 'arrow-left-circle',
  ARROW_RIGHT = 'arrow-right',
  ARROW_RIGHT_CIRCLE = 'arrow-right-circle',
  ARROW_UP = 'arrow-up',
  ARROW_UP_CIRCLE = 'arrow-up-circle',
  ATTRIBUTE = 'attribute',
  A_TO_Z = 'a-to-z',
  BACK_WHITE_CIRCLE = 'back-white-circle',
  BELL_UNDO = 'bell-undo',
  BLUE_ANNOTATE_RESTING = 'blue-annotate-resting',
  BOLD = 'bold',
  BOOK = 'book',
  BOOK_CLOSED = 'book-closed',
  BOOKMARK = 'bookmark',
  BRUSH = 'brush',
  BULB = 'bulb',
  CARET_DOWN = 'caret-down',
  CARET_LEFT = 'caret-left',
  CARET_RIGHT = 'caret-right',
  CARET_UP = 'caret-up',
  CASE = 'case',
  CHART = 'chart',
  CHECKMARK = 'checkmark',
  CHECKMARK_CIRCLE = 'checkmark-circle',
  CHEVRON_DOWN = 'chevron-down',
  CHEVRON_LEFT = 'chevron-left',
  CHEVRON_RIGHT = 'chevron-right',
  CHEVRON_UP = 'chevron-up',
  CHEVRON_RIGHT_DOUBLE = 'chevron-right-double',
  CHEVRON_LEFT_DOUBLE = 'chevron-left-double',
  CIRCLE = 'circle',
  CLOCK = 'clock',
  COG = 'cog',
  COG_WHITE = 'cog-white',
  COMMUNITY = 'community',
  CONDITIONAL_FORMAT = 'conditional-format',
  COPY = 'copy',
  CODE = 'code',
  COPY_LINK = 'copy-link',
  COPY_LINK_CHAIN = 'copy-link-chain',
  CONNECTOR = 'connector',
  CREATE_MONITOR = 'create-monitor',
  CREATE_PINBOARD = 'create-pinboard',
  CREATE_WORKSHEET = 'create-worksheet',
  CROSS = 'cross',
  CROSS_CIRCLE = 'cross-circle',
  DATA_COLUMN = 'data-column',
  DATA_OBJECT = 'data-object',
  DATABASE = 'database',
  DATAROBOT = 'datarobot',
  DEVELOP = 'develop',
  DIVERGING_PATHS = 'diverging-paths',
  DOC_SEARCH_EXCEL = 'doc-search-excel',
  DOC_SEARCH_PDF = 'doc-search-pdf',
  DOC_SEARCH_PPT = 'doc-search-ppt',
  DOC_SEARCH_WORD = 'doc-search-word',
  DOCUMENTATION = 'documentation',
  DOWNLOAD = 'download',
  DRILL_DOWN = 'drill-down',
  EDIT_TEXT = 'edit-text',
  EMBRACE = 'embrace',
  EMPTY = 'empty-icon', // to handle style with empty icons
  EMPTY_CELL = 'empty-cell',
  EMPTY_CIRCLE = 'empty-circle',
  EMPTY_CIRCLE_HOVER = 'empty-circle-hover',
  ENTER = 'enter',
  ESCAPE = 'escape',
  EXCLAMATION_POINT_CIRCLE = 'exclamation-point-circle',
  EXPAND = 'expand',
  EYE = 'eye',
  EYE_UNDO = 'eye-undo',
  FOLLOW = 'follow',
  FOLLOW_UNDO = 'follow-undo',
  FOLLOWING = 'following',
  FORMULA = 'formula',
  FOUR_SQUARES = 'four-squares',
  FULL_SCREEN = 'full-screen',
  FULL_SCREEN_UNDO = 'full-screen-undo',
  FUNNEL = 'funnel',
  GROUP_UNDO = 'group-undo',
  HAMBURGER = 'hamburger',
  INSIGHTS = 'insights',
  ILLUSTRATION = 'illustration',
  INFORMATION = 'information',
  INFORMATION_CIRCLE = 'information-circle',
  ITALIC = 'italic',
  JOIN_INNER = 'join-inner',
  JOIN_LEFT = 'join-left',
  JOIN_OUTER = 'join-outer',
  JOIN_RIGHT = 'join-right',
  KEY = 'key',
  LIGHTNING = 'lightning',
  LOCK = 'lock',
  LOCK_UNDO = 'lock-undo',
  MAGNIFYING_GLASS = 'magnifying-glass',
  MAGNIFYING_GLASS_SMALL = 'magnifying-glass-small',
  MANAGE_MONITOR = 'manage-monitor',
  MEASURE = 'measure',
  MICROPHONE = 'microphone',
  MINUS = 'minus',
  MONITOR = 'monitor',
  MORE = 'more',
  ERROR_ILLUSTRATION = 'error-illustration',
  NAVIGATE = 'navigate',
  NEW_TAB = 'new-tab',
  NINE_SQUARES = 'nine-squares',
  NO_RESULT_FOUND = 'no-result-found',
  NOTIFICATION_BELL = 'notification-bell',
  NOTE = 'note',
  NUMBER_FORMAT = 'number-format',
  PAPER_PLANE = 'paper-plane',
  STOP_SQUARE = 'stop-square',
  PAUSE = 'pause',
  PENCIL = 'pencil',
  PIN = 'pin',
  PINBOARD = 'pinboard',
  PINBOARD_HOME = 'pinboard-home',
  PINBOARD_NEW = 'pinboard-new',
  PLAY = 'play',
  PLUS = 'plus',
  PALETTE = 'palette',
  PALETTE_SELECTED = 'palette-selected',
  POPULAR_STAR = 'popular-star',
  PRESENT = 'present',
  PROFILE = 'profile',
  QUESTION_MARK = 'question-mark',
  R_ANALYSIS = 'r-analysis',
  REDO = 'redo',
  REPLAY_SEARCH = 'replay-search',
  RESET = 'reset',
  ROCKET = 'rocket',
  SAVE = 'save',
  SAVE_WORKSHEET = 'save-worksheet',
  SCHEMA = 'schema',
  SEARCH_DATA = 'search-data',
  SHARE = 'share',
  SHOW_UNDERLYING_DATA = 'show-underlying-data',
  SIGN_OUT = 'sign-out',
  SPREAD_SHEET = 'spread-sheet',
  SPREAD_SHEET_WHITE = 'spread-sheet-white',
  SPOTTER_MENU = 'spotter-menu',
  SPOTTER = 'spotter',
  SPOTTER_CODE = 'spotter-code',
  SPOTTER_NEW = 'spotter-new',
  SORT = 'sort',
  STAR = 'star',
  STAR_UNDO = 'star-undo',
  STAR_FILLED = 'star-filled',
  STRIKE_THROUGH = 'strike-through',
  SYNC = 'sync',
  TAG = 'tag',
  TEXT = 'text',
  TEXT_UNDO = 'text-undo',
  THOUGHTSPOT = 'thoughtspot',
  THOUGHTSPOT_FULL = 'thoughtspot-full',
  THUMB_DOWN = 'thumb-down',
  THUMB_DOWN_UNDO = 'thumb-down-undo',
  THUMB_UP = 'thumb-up',
  THUMB_UP_UNDO = 'thumb-up-undo',
  TRASH_CAN = 'trash-can',
  TRENDING_EMPTY = 'trending-empty',
  UNDO = 'undo',
  UPLOAD = 'upload',
  UPLOAD_DATA = 'upload-data',
  UNDERLINE = 'underline',
  VIDEO = 'video',
  WRENCH = 'wrench',
  ZOOM_AREA = 'zoom-area',
  CAMERA = 'camera',
  SQL_WORKSHEET = 'sql-worksheet',
  SQL_BASED_VIEW = 'sql-based-view',
  SQL_TABLE = 'sql-table',
  SQL_VIEW = 'sql-view',
  SAGE_VIEW = 'sage-view',
  SNOWFLAKE_CONNECTION = 'snow-flake-connection',
  BLACK_CIRCLE = 'black-circle',
  GREY_CIRCLE = 'grey-circle',
  INFO_BUTTON = 'info-button',
  MENU_ICON = 'menu-icon',
  DRAG_HANDLE = 'drag-handle',
  VLB_WHITE = 'vlb-white',
  VLB_COLOR = 'vlb-color',
  VERIFIED_WHITE = 'verified-white',
  VERIFIED = 'verified',
  VERIFIED_COLOR = 'verified-color',
  VERIFIED_OUTLINE = 'verified-outline',
  SUPER_G = 'super-g',
  DRAG_HANDLE_V2 = 'drag-handle-v2',
  TABLE = 'table',
  IMAGE = 'image',
  EMBEDED = 'embeded',
  DIVIDER = 'divider',
  TEXT_ALIGN_RIGHT = 'text-align-right',
  TEXT_ALIGN_LEFT = 'text-align-left',
  TEXT_ALIGN_CENTER = 'text-align-center',
  TEXT_ALIGN_JUSTIFY = 'text-align-justify',
  TITLE = 'title',
  HEADING = 'heading',
  BULLET_LIST = 'bullet-list',
  NUMBERED_LIST = 'numbered-list',
  FONT_COLOR = 'font-color',
  LINK = 'link',
  LIVEBOARD_OUTLINE = 'liveboard-outline',
  OPEN = 'open',
  AI_WHITE = 'ai-white',
  UNION_TOGGLE = 'union',
  UNION_TOGGLE_ACTIVE = 'union-active',
  UNION_ON_STATE = 'union-on-state',
  SIDE_PANEL_OPEN = 'side-panel-open',
  SIDE_PANEL_CLOSED = 'side-panel-closed',
  TICK_SELECTION_BLUE = 'tick-selection-blue',
  EXPORT_BY_VIZ = 'export-by-viz',
  EXPORT_LIVEBOARD = 'export-liveboard',
  ANALYST_STUDIO = 'analyst-studio',
  OPEN_IN_NEW_TAB = 'open-in-new-tab',
  LEGACY_OPEN_IN_NEW_TAB = 'legacy-open-in-new-tab',
  LINK_ITEM = 'link-item',
  UNLINK_ITEM = 'unlink-item',
  OKTA_PROVIDER = 'okta-provider',
  GOOGLE_AUTH_PROVIDER = 'google-auth-provider',
  EMAIL_PROVIDER = 'email-provider',
  NOTIFICATION = 'notification',
  TEXT_V2 = 'text-v2',
  WRAP = 'wrap',
  PERCENT = 'percent',
  DOLLAR = 'dollar',
  TEXT_STYLE = 'text-style',
  TEXT_COLOR = 'text-color',
  PERCENTAGE = 'percentage',
  NUMBER_FORMAT_STYLE = 'number-format-style',
  LINE_THICKNESS = 'line-thickness',
  SOLID_LINE = 'solid-line',
  DASH_LINE = 'dash-line',
  DOT_LINE = 'dot-line',
  SQUARE = 'square',
  TRIANGLE = 'triangle',
  WIDTH = 'width',
  TRIANGLE_DOWN = 'triangle-down',
  MARKER_CIRCLE = 'marker-circle',
  MARKER_SQUARE = 'marker-square',
  MARKER_TRIANGLE = 'marker-triangle',
  MARKER_DIAMOND = 'marker-diamond',
  MARKER_TRIANGLE_DOWN = 'marker-triangle-down',
  BACKGROUND_COLOR = 'background-color',
  BORDER_COLOR = 'border-color',
  CHART_TYPE_SETTINGS = 'chart-type-settings',
  LAYOUT_SETTINGS = 'layout-settings',
  COLUMN_SETTINGS = 'column-settings',
  AXIS_SETTINGS = 'axis-settings',
  DATA_LABEL_SETTINGS = 'data-label-settings',
  TOOLTIP_SETTINGS = 'tooltip-settings',
  LEGEND_SETTINGS = 'legend-settings',
  DISPLAY_SETTINGS = 'display-settings',
  ANSWER_QUERY = 'answer-query',
  R_ANALYSIS_V2 = 'r-analysis-v2',
  CUSTOM_ACTIONS = 'custom-actions',
  SERVICENOW = 'servicenow',
  SALESFORCE = 'salesforce',
  PETSPOT = 'petspot',
  HOCKEY_STORE = 'hockey-store',
  RETAIL_APPAREL = 'retail-apparel',
  SALESFORCE_WHITE = 'salesforce-white',
  PETSPOT_WHITE = 'petspot-white',
  HOCKEY_STORE_WHITE = 'hockey-store-white',
  RETAIL_APPAREL_WHITE = 'retail-apparel-white',
  CONNECTOR_WHITE = 'connector-white',
  CSV = 'csv',
  CSV_WHITE = 'csv-white',
  GOOGLE_SHEET = 'google-sheet',
  GOOGLE_SHEET_WHITE = 'google-sheet-white',
  IMPORT_DOC = 'import-doc',
  DOC_GREEN = 'doc-green',
  DATA_LOAD_FAILED = 'data-load-failed',
  FILE_DEFAULT_STATE = 'file-default-state',
  FILE_ADDED_STATE = 'file-added-state',
  STYLING_PANEL_OPEN = 'styling-panel-open',
  STYLING_PANEL_CLOSE = 'styling-panel-close',
  ADD_TAB = 'add-tab',
  PENCIL_LINE = 'pencil-line',
  MOVE_TO = 'move-to',
  SCALE = 'scale',
  DUPLICATE = 'duplicate',
  TRASH_CAN_LINE = 'trash-can-line',
  GROUP = 'group',
  UPDOWN_ARROW = 'updown-arrow',
  UNGROUP = 'ungroup',
  TEXT_STYLING = 'text-styling',
  DENSITY_TIGHT = 'density-tight',
  DENSITY_REGULAR = 'density-regular',
  DENSITY_LOOSE = 'density-loose',
  DENSITY_TIGHT_ACTIVE = 'density-tight-active',
  DENSITY_REGULAR_ACTIVE = 'density-regular-active',
  DENSITY_LOOSE_ACTIVE = 'density-loose-active',
  CORNER_SHARP = 'corner-sharp',
  CORNER_CURVED = 'corner-curved',
  CORNER_SHARP_ACTIVE = 'corner-sharp-active',
  CORNER_CURVED_ACTIVE = 'corner-corved-active',
  LB_GUTTERED = 'lb-guttered',
  LB_GUTTERED_ACTIVE = 'lb-guttered-active',
  LB_GUTTERLESS = 'lb-gutterless',
  LB_GUTTERLESS_ACTIVE = 'lb-gutterless-active',
  DATA_WORKSPACE = 'data-workspace',
  LOCK_GREY = 'lock-grey',
  ADD_NOTE_OUTLINE = 'add-note-outline',
  ADD_TAB_OUTLINE = 'add-tab-outline',
  FILTER_OUTLINE = 'filter-outline',
  GROUP_OUTLINE = 'group-outline',
  PARAMETER = 'parameter',
  SOURCE_TABLE = 'source-table',
  SET = 'set',
  CALENDAR = 'calendar',
  PANEL_OPEN = 'panel-open',
  PANEL_CLOSE = 'panel-close',
  ORANGE_GITHUB = 'orange-github',
  YOUTUBE = 'youtube',
  CHAT = 'chat',
  EXPAND_SCREEN = 'expand-screen',
  COLLAPSE_SCREEN = 'collapse-screen',
  SPOTTER_DEEP_ANALYSIS_MODE = 'deep-analysis',
  SPOTTER_MODE = 'spotter-mode',
  TABLE_WRAP = 'table-wrap',
  TABLE_CLIP = 'table-clip',
  ANSWER_V2 = 'answer-v2',
  LIVEBOARD_V2 = 'pinboard-v2',
  SPOTTER_V2 = 'spotter-v2',
  SAGE_V2 = 'sage-v2',
  FULLAPP_V2 = 'fullapp-v2',
  SEARCH_V2 = 'search-v2',
  WORKSHEET_FORMAT = 'worksheet-format',
  STACKBLITZ = 'stackblitz',
  DATA_SOURCE = 'data-source',
  COLLECTION = 'collection',
  COLLECTION_ALERT = 'collectionalert',
  SPOTTER_TOOLS = 'spotter-tools',
  SPOTTER_VIZ = 'spotter-viz',
  CHART_ADVANCED_PIVOT_TABLE = 'chart-advanced-pivot-table',
  CHART_ADVANCED_COLUMN = 'chart-advanced-column',
  CHART_ADVANCED_STACKED_COLUMN = 'chart-advanced-stacked-column',
  CHART_ADVANCED_BAR = 'chart-advanced-bar',
  CHART_ADVANCED_STACKED_BAR = 'chart-advanced-stacked-bar',
  CHART_ADVANCED_LINE = 'chart-advanced-line',
  CHART_ADVANCED_AREA = 'chart-advanced-area',
  CHART_ADVANCED_STACKED_AREA = 'chart-advanced-stacked-area',
  CHART_ADVANCED_LINE_COLUMN = 'chart-advanced-line-column',
  CHART_ADVANCED_LINE_STACKED_COLUMN = 'chart-advanced-line-stacked-column',
  CHART_AREA = 'chart-area',
  CHART_BAR = 'chart-bar',
  CHART_BUBBLE = 'chart-bubble',
  CHART_CANDLESTICK = 'chart-candlestick',
  CHART_COLUMN = 'chart-column',
  CHART_CUSTOM_CHART = 'chart-custom-chart',
  CHART_DATA_TABLE_COLORED = 'chart-data-table-colored',
  CHART_DATA_TABLE = 'chart-data-table',
  CHART_FUNNEL = 'chart-funnel',
  CHART_GEO_AREA = 'chart-geo-area',
  CHART_GEO_BUBBLE = 'chart-geo-bubble',
  CHART_GEO_HEATMAP = 'chart-geo-heatmap',
  CHART_HEADLINE = 'chart-headline',
  CHART_HEATMAP = 'chart-heatmap',
  CHART_HISTOGRAM = 'chart-histogram',
  CHART_IMPORTED_DATA_TABLE = 'chart-imported-data-table',
  CHART_KPI = 'chart-kpi',
  CHART_LINE_COLUMN = 'chart-line-column',
  CHART_LINE_STACKED_COLUMN = 'chart-line-stacked-column',
  CHART_LINE = 'chart-line',
  CHART_LOADING_CHART = 'chart-loading-chart',
  CHART_MUZE_STUDIO = 'chart-muze-studio',
  CHART_PARETO = 'chart-pareto',
  CHART_PIE_OLD = 'chart-pie-old',
  CHART_PIE = 'chart-pie',
  CHART_PIVOT_TABLE = 'chart-pivot-table',
  CHART_RADAR_MULTI = 'chart-radar-multi',
  CHART_SANKEY = 'chart-sankey',
  CHART_SCATTER = 'chart-scatter',
  CHART_SPIDER_WEB = 'chart-spider-web',
  CHART_SPOTIQ_ANOMALY_LESS = 'chart-spotiq-anomaly-less',
  CHART_SPOTIQ_ANOMALY_MORE = 'chart-spotiq-anomaly-more',
  CHART_SPOTIQ_BAR_LESS = 'chart-spotiq-bar-less',
  CHART_SPOTIQ_BAR_MORE = 'chart-spotiq-bar-more',
  CHART_SPOTIQ_COLUMN_LESS = 'chart-spotiq-column-less',
  CHART_SPOTIQ_COLUMN_MORE = 'chart-spotiq-column-more',
  CHART_SPOTIQ_CORRELATION_COLUMN_NEGATIVE = 'chart-spotiq-correlation-column-negative',
  CHART_SPOTIQ_CORRELATION_COLUMN_POSITIVE = 'chart-spotiq-correlation-column-positive',
  CHART_SPOTIQ_CORRELATION_LINE_NEGATIVE = 'chart-spotiq-correlation-line-negative',
  CHART_SPOTIQ_CORRELATION_LINE_POSITIVE = 'chart-spotiq-correlation-line-positive',
  CHART_SPOTIQ_DONUT_LESS = 'chart-spotiq-donut-less',
  CHART_SPOTIQ_DONUT_MORE = 'chart-spotiq-donut-more',
  CHART_SPOTIQ_SCATTER_LESS = 'chart-spotiq-scatter-less',
  CHART_SPOTIQ_SCATTER_MORE = 'chart-spotiq-scatter-more',
  CHART_SPOTIQ_TREND_LINE_DOWNWARD = 'chart-spotiq-trend-line-downward',
  CHART_SPOTIQ_TREND_LINE_UPWARD = 'chart-spotiq-trend-line-upward',
  CHART_SPOTIQ_TREND_LINE_ZERO = 'chart-spotiq-trend-line-zero',
  CHART_SPOTIQ_TREND_SCATTER_DOWNWARD = 'chart-spotiq-trend-scatter-downward',
  CHART_SPOTIQ_TREND_SCATTER_UPWARD = 'chart-spotiq-trend-scatter-upward',
  CHART_SPOTIQ_TREND_SCATTER_ZERO = 'chart-spotiq-trend-scatter-zero',
  CHART_STACKED_AREA = 'chart-stacked-area',
  CHART_STACKED_BAR = 'chart-stacked-bar',
  CHART_STACKED_COLUMN = 'chart-stacked-column',
  CHART_TABLE = 'chart-table',
  CHART_TREEMAP = 'chart-treemap',
  CHART_WATERFALL = 'chart-waterfall',
  CHART_WORKSHEET = 'chart-worksheet',
  FLIP_ARROWS = 'flip-arrows',
  LEFT_PANEL_OPEN = 'left-panel-open',
  LEFT_PANEL_CLOSE = 'left-panel-close',
  AI_MODE = 'ai-mode',
  MANUAL_MODE = 'manual-mode',
  LOGO = 'logo',
}
